<div id="designer"></div>
<kl-preference-form (onSetPreference)="commitSave($event)"></kl-preference-form>
